module.exports = __webpack_public_path__ + "img/row-right.a708ef70.png";